import React from 'react'

import { cn } from '@/lib/utils.ts'

export interface AutomationSpecificationsItem {
  name: string
  level: 'manual' | 'automatic' | 'best'
  levelName: string
}

export interface AutomationSpecificationsProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  items?: AutomationSpecificationsItem[]
}

const levelTextColor = (item: AutomationSpecificationsItem) => {
  switch (item.level) {
    case 'automatic':
      return 'text-blue-600'
    case 'best':
      return 'text-green-500'
    default:
      return 'text-black'
  }
}

export const AutomationSpecifications = React.forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<AutomationSpecificationsProps>
>(({ className, items, children, ...props }, ref) => (
  <div
    className={cn(
      'flex w-[312px] flex-col gap-4 rounded-[8px] border border-black bg-white px-4 py-5 shadow-xl',
      className
    )}
    ref={ref}
    {...props}>
    {children}

    <div className="flex flex-col gap-2.5">
      {items?.map((item, index) => (
        <div key={item.name} className="flex flex-col gap-2 select-none">
          <div className="flex items-center justify-between px-1">
            <p className="text-[10px] leading-[120%] text-black">{item.name}</p>
            <p className={cn('text-sm font-bold', levelTextColor(item))}>{item.levelName}</p>
          </div>
          {index < items.length - 1 && <hr className="border-gray-400" />}
        </div>
      ))}
    </div>
  </div>
))
